import React from "react";
import BlogForm from "../component/Admin/BlogForm";
import { useNavigate } from "react-router";
import { FiLogOut } from "react-icons/fi"; 
import { adminEndpoints } from "../services/api";

export default function ManageBlog() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem("token")
    navigate("/admin/login");
  };

  return (
    <div className="w-full bg-[#0F172A] overflow-hidden flex flex-col min-h-screen p-4 relative">
      <button
        onClick={handleLogout}
        className="absolute md:top-[10%] top-[6%] right-4 flex items-center gap-2 bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition duration-200"
      >
        <FiLogOut size={24} /> 
        <span className="hidden sm:inline">Logout</span> 
      </button>

      {/* Blog Form Section */}
      <div className="w-full mt-[12%] ">
        <BlogForm />
      </div>
    </div>
  );
}
